import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar la “falta de cierre”",
    opening: localizedGenderNode(
      [
      "Hoy dejo de llamarlo “locura”. Lo llamo por su nombre: falta de cierre — y desde aquí empiezo.",
      "Pauso conmigo."
    ],
      [
      "Hoy dejo de llamarlo “locura”. Lo llamo por su nombre: falta de cierre — y desde aquí empiezo.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración lenta.",
      "Me digo en silencio: “Mi mente busca una respuesta para sentirse segura”."
    ],
      [
      "Una respiración lenta.",
      "Me digo en silencio: “Mi mente busca una respuesta para sentirse segura”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura — para mí\nMe pregunto:\n¿Qué es exactamente lo que quedó abierto para mí?\n(¿Qué siento que necesito entender / escuchar / ver?)",
      "Me pregunto:\n¿Qué temo que ocurra si nunca sé el “por qué”?",
      "Me pregunto:\n¿Qué hago una y otra vez para intentar conseguir cierre?\n(mandar mensajes / revisar / revivir / imaginar conversaciones)"
    ],
      [
      "Escritura — para mí\nMe pregunto:\n¿Qué es exactamente lo que quedó abierto para mí?\n(¿Qué siento que necesito entender / escuchar / ver?)",
      "Me pregunto:\n¿Qué temo que ocurra si nunca sé el “por qué”?",
      "Me pregunto:\n¿Qué hago una y otra vez para intentar conseguir cierre?\n(mandar mensajes / revisar / revivir / imaginar conversaciones)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La falta de cierre es un dolor real. Hoy dejo de culparme por sentirlo."
    ],
      [
      "Cierre",
      "La falta de cierre es un dolor real. Hoy dejo de culparme por sentirlo."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: una respiración + la frase:",
      "Una vez hoy: una respiración + la frase:"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Historia vs. hecho",
    opening: localizedGenderNode(
      [
      "Hoy separo lo que sé de lo que mi mente intenta completar.",
      "Pauso conmigo."
    ],
      [
      "Hoy separo lo que sé de lo que mi mente intenta completar.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “No todos los vacíos deben cerrarse hoy”."
    ],
      [
      "Una respiración. “No todos los vacíos deben cerrarse hoy”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuáles son los hechos concretos que realmente sé?\n(2–4 líneas, sin interpretación)",
      "¿Qué no sé y trato de llenar con imaginación?",
      "¿Qué historia construye mi dolor sobre lo que no sé?",
      "¿Qué verdad suave puedo elegir hoy en lugar de esa historia?"
    ],
      [
      "Escritura\n¿Cuáles son los hechos concretos que realmente sé?\n(2–4 líneas, sin interpretación)",
      "¿Qué no sé y trato de llenar con imaginación?",
      "¿Qué historia construye mi dolor sobre lo que no sé?",
      "¿Qué verdad suave puedo elegir hoy en lugar de esa historia?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Puedo vivir con el “no sé” sin dejar que dirija mi vida."
    ],
      [
      "Cierre",
      "Puedo vivir con el “no sé” sin dejar que dirija mi vida."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy: “Vuelvo a los hechos”. Luego una respiración.",
      "Una vez hoy: “Vuelvo a los hechos”. Luego una respiración."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El impulso de preguntar o buscar respuestas (protocolo 90 segundos)",
    opening: localizedGenderNode(
      [
      "Hoy creo una pausa antes de cualquier acción que intente forzar el cierre.",
      "Pauso conmigo."
    ],
      [
      "Hoy creo una pausa antes de cualquier acción que intente forzar el cierre.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Me elijo primero”."
    ],
      [
      "Una respiración. “Me elijo primero”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué impulso aparece hoy?\n(escribir / preguntar a otros / revisar / analizar)",
      "¿Qué intento calmar con este impulso?\n(incertidumbre / dolor / humillación / miedo al abandono)",
      "Protocolo de 90 segundos (desde hoy):\n* 3 respiraciones lentas\n* Observar el cuerpo: ¿dónde se siente el impulso?\n* Una frase interna: “Esto es un impulso. Pasará”.\nLuego elegir una alternativa pequeña.\n\n¿Qué alternativa elijo hoy en lugar de buscar respuestas?"
    ],
      [
      "Escritura\n¿Qué impulso aparece hoy?\n(escribir / preguntar a otros / revisar / analizar)",
      "¿Qué intento calmar con este impulso?\n(incertidumbre / dolor / humillación / miedo al abandono)",
      "Protocolo de 90 segundos (desde hoy):\n* 3 respiraciones lentas\n* Observar el cuerpo: ¿dónde se siente el impulso?\n* Una frase interna: “Esto es un impulso. Pasará”.\nLuego elegir una alternativa pequeña.\n\n¿Qué alternativa elijo hoy en lugar de buscar respuestas?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No necesito actuar para calmarme. Puedo calmarme sin respuestas."
    ],
      [
      "Cierre",
      "No necesito actuar para calmarme. Puedo calmarme sin respuestas."
    ]
    ),
    action: localizedGenderNode(
      "Cada vez que surja el impulso — hago el protocolo una sola vez.",
      "Cada vez que surja el impulso — hago el protocolo una sola vez."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Qué busco realmente dentro del “cierre”",
    opening: localizedGenderNode(
      [
      "Hoy descubro que lo que busco es más profundo que información.",
      "Pauso conmigo."
    ],
      [
      "Hoy descubro que lo que busco es más profundo que información.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Quizás no busco datos, sino calma”."
    ],
      [
      "Una respiración. “Quizás no busco datos, sino calma”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\nSi recibiera la “respuesta perfecta”, ¿qué sentiría por un momento?",
      "¿Qué necesidad se esconde ahí?\n(respeto / validación / comprensión / justicia / pertenencia / seguridad)",
      "¿Cómo puedo darme hoy un 10% de esa necesidad sin la otra persona?"
    ],
      [
      "Escritura\nSi recibiera la “respuesta perfecta”, ¿qué sentiría por un momento?",
      "¿Qué necesidad se esconde ahí?\n(respeto / validación / comprensión / justicia / pertenencia / seguridad)",
      "¿Cómo puedo darme hoy un 10% de esa necesidad sin la otra persona?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "A veces el cierre no es lo que el otro dice, sino lo que yo me doy."
    ],
      [
      "Cierre",
      "A veces el cierre no es lo que el otro dice, sino lo que yo me doy."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una necesidad y le doy una forma pequeña hoy",
      "Elijo una necesidad y le doy una forma pequeña hoy"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El dolor de no haber recibido respeto",
    opening: localizedGenderNode(
      [
      "Hoy toco el lugar donde no fui tratado como necesitaba.",
      "Pauso conmigo."
    ],
      [
      "Hoy toco el lugar donde no fui tratado como necesitaba.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Tengo derecho a dolerme por la falta de respeto”."
    ],
      [
      "Una respiración. “Tengo derecho a dolerme por la falta de respeto”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué respeto me faltó en la relación o en la ruptura?",
      "¿Qué frase necesitaba escuchar y no escuché?",
      "¿Qué frase de respeto puedo decirme hoy a mí mismo/a?"
    ],
      [
      "Escritura\n¿Qué respeto me faltó en la relación o en la ruptura?",
      "¿Qué frase necesitaba escuchar y no escuché?",
      "¿Qué frase de respeto puedo decirme hoy a mí mismo/a?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Si no recibí respeto desde afuera, empiezo a dármelo desde dentro."
    ],
      [
      "Cierre",
      "Si no recibí respeto desde afuera, empiezo a dármelo desde dentro."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una frase de autorrespeto y la guardo en mi diario.",
      "Escribo una frase de autorrespeto y la guardo en mi diario."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Culpa y auto-crítica",
    opening: localizedGenderNode(
      [
      "Hoy dejo de castigarme en nombre de las explicaciones.",
      "Pauso conmigo."
    ],
      [
      "Hoy dejo de castigarme en nombre de las explicaciones.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Asumir responsabilidad no es romperme”."
    ],
      [
      "Una respiración. “Asumir responsabilidad no es romperme”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué historia de culpa repito para explicar lo ocurrido?",
      "¿Qué parte pequeña sí es mía — y qué no lo es?",
      "¿Cómo puedo decir lo mismo con un tono más suave?"
    ],
      [
      "Escritura\n¿Qué historia de culpa repito para explicar lo ocurrido?",
      "¿Qué parte pequeña sí es mía — y qué no lo es?",
      "¿Cómo puedo decir lo mismo con un tono más suave?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La responsabilidad sin compasión no cierra ciclos; abre heridas."
    ],
      [
      "Cierre",
      "La responsabilidad sin compasión no cierra ciclos; abre heridas."
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparezca la culpa — vuelvo a mi frase suave una sola vez.",
      "Cuando aparezca la culpa — vuelvo a mi frase suave una sola vez."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "La carta que no se envía",
    opening: localizedGenderNode(
      [
      "Hoy le doy a mi mente un final, aunque no haya conversación real.",
      "Pauso conmigo."
    ],
      [
      "Hoy le doy a mi mente un final, aunque no haya conversación real.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Puedo escribir cierre aunque no lo haya recibido”."
    ],
      [
      "Una respiración. “Puedo escribir cierre aunque no lo haya recibido”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\nCarta que no se envía (6–10 líneas):\n¿Qué quiero decir realmente, sin disculparme ni atacar?",
      "¿Qué frase es el corazón de esta carta?",
      "¿Qué suelto hoy del deseo de que “me entiendan”?"
    ],
      [
      "Escritura\nCarta que no se envía (6–10 líneas):\n¿Qué quiero decir realmente, sin disculparme ni atacar?",
      "¿Qué frase es el corazón de esta carta?",
      "¿Qué suelto hoy del deseo de que “me entiendan”?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El cierre no siempre viene de afuera. A veces es un acto interno de respeto."
    ],
      [
      "Cierre",
      "El cierre no siempre viene de afuera. A veces es un acto interno de respeto."
    ]
    ),
    action: localizedGenderNode(
      "Leo la carta una vez y luego la cierro. No analizo más.",
      "Leo la carta una vez y luego la cierro. No analizo más."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Aceptación suave (ACT)",
    opening: localizedGenderNode(
      [
      "Hoy practico sostener la incertidumbre un momento sin huir.",
      "Pauso conmigo."
    ],
      [
      "Hoy practico sostener la incertidumbre un momento sin huir.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Esto es incertidumbre. Y es soportable”."
    ],
      [
      "Una respiración. “Esto es incertidumbre. Y es soportable”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué disparador activa más mi necesidad de cierre?",
      "Práctica de un minuto: dejo que el “no sé” esté aquí un minuto sin actuar.\n¿Qué ocurrió en mi cuerpo después del minuto?",
      "¿Qué aprendí? ¿La ola realmente no pasó?"
    ],
      [
      "Escritura\n¿Qué disparador activa más mi necesidad de cierre?",
      "Práctica de un minuto: dejo que el “no sé” esté aquí un minuto sin actuar.\n¿Qué ocurrió en mi cuerpo después del minuto?",
      "¿Qué aprendí? ¿La ola realmente no pasó?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Me fortalezco no porque obtuve respuestas, sino porque permanecí."
    ],
      [
      "Cierre",
      "Me fortalezco no porque obtuve respuestas, sino porque permanecí."
    ]
    ),
    action: localizedGenderNode(
      "Un minuto solamente. Constancia > fuerza.",
      "Un minuto solamente. Constancia > fuerza."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Soltar la fantasía de la conversación perfecta",
    opening: localizedGenderNode(
      [
      "Hoy dejo ir la escena que mi mente monta para calmarse.",
      "Pauso conmigo."
    ],
      [
      "Hoy dejo ir la escena que mi mente monta para calmarse.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Las escenas mentales no me devuelven la vida”."
    ],
      [
      "Una respiración. “Las escenas mentales no me devuelven la vida”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cómo se ve la conversación perfecta en mi mente?",
      "¿Qué intento recibir ahí?\n(reconocimiento / disculpa / explicación / que me elijan)",
      "¿Qué parte pequeña puedo darme hoy a mí mismo/a?"
    ],
      [
      "Escritura\n¿Cómo se ve la conversación perfecta en mi mente?",
      "¿Qué intento recibir ahí?\n(reconocimiento / disculpa / explicación / que me elijan)",
      "¿Qué parte pequeña puedo darme hoy a mí mismo/a?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Suelto el escenario interno y devuelvo energía a mi vida."
    ],
      [
      "Cierre",
      "Suelto el escenario interno y devuelvo energía a mi vida."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy, cuando empiece a imaginar la conversación — digo “ahora no” y vuelvo a la respiración.",
      "Una vez hoy, cuando empiece a imaginar la conversación — digo “ahora no” y vuelvo a la respiración."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Límites conmigo",
    opening: localizedGenderNode(
      [
      "Hoy pongo un límite que me protege de reabrir la herida.",
      "Pauso conmigo."
    ],
      [
      "Hoy pongo un límite que me protege de reabrir la herida.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Un límite es protección”."
    ],
      [
      "Una respiración. “Un límite es protección”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué acción abre más la herida?",
      "¿Qué límite pequeño pongo esta semana?\n(“Esta semana no voy a _ para cuidarme”)",
      "¿Qué miedo surge si mantengo este límite?",
      "¿Qué respuesta suave puedo darle a ese miedo?"
    ],
      [
      "Escritura\n¿Qué acción abre más la herida?",
      "¿Qué límite pequeño pongo esta semana?\n(“Esta semana no voy a _ para cuidarme”)",
      "¿Qué miedo surge si mantengo este límite?",
      "¿Qué respuesta suave puedo darle a ese miedo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No me castigo. Me protejo."
    ],
      [
      "Cierre",
      "No me castigo. Me protejo."
    ]
    ),
    action: localizedGenderNode(
      "Elimino u oculto un disparador (chat / foto / redes) que enciende la necesidad.",
      "Elimino u oculto un disparador (chat / foto / redes) que enciende la necesidad."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Recuperar control",
    opening: localizedGenderNode(
      [
      "Hoy reduzco la tormenta a un solo paso.",
      "Pauso conmigo."
    ],
      [
      "Hoy reduzco la tormenta a un solo paso.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Un paso es suficiente”."
    ],
      [
      "Una respiración. “Un paso es suficiente”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué me abruma más hoy respecto a la falta de cierre?",
      "¿Qué 3 cosas muy pequeñas sí están bajo mi control hoy?",
      "¿Qué paso único doy hoy?"
    ],
      [
      "Escritura\n¿Qué me abruma más hoy respecto a la falta de cierre?",
      "¿Qué 3 cosas muy pequeñas sí están bajo mi control hoy?",
      "¿Qué paso único doy hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El control vuelve a través de acciones pequeñas, no de grandes respuestas."
    ],
      [
      "Cierre",
      "El control vuelve a través de acciones pequeñas, no de grandes respuestas."
    ]
    ),
    action: localizedGenderNode(
      "Hago el paso elegido — y nada más.",
      "Hago el paso elegido — y nada más."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Bucles nocturnos",
    opening: localizedGenderNode(
      [
      "Hoy le doy a mi mente una señal de “fin del día”.",
      "Pauso conmigo."
    ],
      [
      "Hoy le doy a mi mente una señal de “fin del día”.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Esta noche no tengo que resolver”."
    ],
      [
      "Una respiración. “Esta noche no tengo que resolver”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es mi bucle nocturno más común?",
      "¿Qué intenta conseguir este bucle por mí?",
      "¿Qué frase de cierre elijo para esta noche?",
      "¿Qué ritual de 3 minutos me ayudará antes de dormir?"
    ],
      [
      "Escritura\n¿Cuál es mi bucle nocturno más común?",
      "¿Qué intenta conseguir este bucle por mí?",
      "¿Qué frase de cierre elijo para esta noche?",
      "¿Qué ritual de 3 minutos me ayudará antes de dormir?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una mente cansada crea historias intensas. Esta noche elijo descanso."
    ],
      [
      "Cierre",
      "Una mente cansada crea historias intensas. Esta noche elijo descanso."
    ]
    ),
    action: localizedGenderNode(
      "Antes de dormir: mi frase de cierre + una respiración. Eso es todo.",
      "Antes de dormir: mi frase de cierre + una respiración. Eso es todo."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Convertir lo abierto en dirección",
    opening: localizedGenderNode(
      [
      "Hoy lo “inconcluso” se convierte en brújula.",
      "Pauso conmigo."
    ],
      [
      "Hoy lo “inconcluso” se convierte en brújula.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Si dolió, me enseña algo”."
    ],
      [
      "Una respiración. “Si dolió, me enseña algo”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué me enseña esto sobre lo que necesito en relaciones futuras o en mi vida?",
      "¿Qué valor me guiará ahora?\n(respeto / verdad / calma / estabilidad)",
      "¿Qué hábito pequeño me acerca a ese valor esta semana?",
      "¿Qué promesa me hago cuando aparezca el impulso de forzar el cierre?"
    ],
      [
      "Escritura\n¿Qué me enseña esto sobre lo que necesito en relaciones futuras o en mi vida?",
      "¿Qué valor me guiará ahora?\n(respeto / verdad / calma / estabilidad)",
      "¿Qué hábito pequeño me acerca a ese valor esta semana?",
      "¿Qué promesa me hago cuando aparezca el impulso de forzar el cierre?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No necesito quedarme atrapado/a en el pasado para construir futuro."
    ],
      [
      "Cierre",
      "No necesito quedarme atrapado/a en el pasado para construir futuro."
    ]
    ),
    action: localizedGenderNode(
      "Planifico una cosa pequeña esta semana que me devuelva sensación de futuro.",
      "Planifico una cosa pequeña esta semana que me devuelva sensación de futuro."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Ritual suave de cierre",
    opening: localizedGenderNode(
      [
      "Hoy cierro un capítulo sin borrarlo. Me quedo conmigo.",
      "Pauso conmigo."
    ],
      [
      "Hoy cierro un capítulo sin borrarlo. Me quedo conmigo.",
      "Pauso conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Suelto sin desaparecer”."
    ],
      [
      "Una respiración. “Suelto sin desaparecer”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\nTres cosas que dejo de hacer para proteger mi corazón:",
      "Tres cosas que empiezo a hacer para construirme:",
      "Frase de regreso para días difíciles (corta, clara):"
    ],
      [
      "Escritura\nTres cosas que dejo de hacer para proteger mi corazón:",
      "Tres cosas que empiezo a hacer para construirme:",
      "Frase de regreso para días difíciles (corta, clara):"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del recorrido",
      "Tal vez nunca reciba la respuesta que quería.",
      "Pero sí puedo recuperar mi vida.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ],
      [
      "Cierre final del recorrido",
      "Tal vez nunca reciba la respuesta que quería.",
      "Pero sí puedo recuperar mi vida.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una acción que simbolice “un nuevo capítulo”:",
      "Elijo una acción que simbolice “un nuevo capítulo”:"
    ),
  },
].map(buildNormalizedDay);

export const lackOfClosureAfterBreakupBlueprintEs = buildNormalizedPilotBlueprint({
  id: "lack_of_closure_after_breakup_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "lack_of_closure_after_breakup",
  category: "general",
  journeyName: {
    he: "חוסר סגירה ופרידה לא פתורה",
    en: "Lack of Closure & Unresolved Separation",
    es: "Falta de cierre y separación no resuelta",
  },
  days,
});

export default lackOfClosureAfterBreakupBlueprintEs;
